module.exports = __webpack_public_path__ + "static/media/slider-l1.540ec2d9.webp";